import React, { useState, useEffect } from 'react';
import { Card, Grid, Button, } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useSelector, useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import history from 'history.js';
import clsx from 'clsx';
import useAuth from 'app/hooks/useAuth';

import { Redirect, NavLink } from 'react-router-dom';

import { login, } from './thunk';
import './Login.scss';

import Amplify from '@aws-amplify/core';
import { Auth, API } from "aws-amplify";


Amplify.configure({
    Auth: {
        // REQUIRED - Amazon Cognito Identity Pool ID
        identityPoolId: 'ap-northeast-1:4d252c84-69cb-45b0-981f-fb460edb624a',
        // REQUIRED - Amazon Cognito Region
        region: 'ap-northeast-1',
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'ap-northeast-1_KdoeaRZMU',
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: '21eg9cvrjl6cl9fo1c14napb2j',
        oauth: {},
    }
});

const AuthClass = () => {

    const [loading, setLoading] = useState(false);
    //const [userInfo, setUserInfo] = useState({ email: 'jason@ui-lib.com', password: 'dummyPass', });
    const [userInfo, setUserInfo] = useState({ id: localStorage.getItem("ssvId"), password: localStorage.getItem("ssvPw"), });
    const [messageLogin, setMessageLogin] = useState('');
    //const [errorMegId, setErrorMegId] = useState('入力してください');
    // const [errorMegPw, setErrorMegPw] = useState('入力してください');

    //const { signInWithEmailAndPassword } = useAuth();

    Amplify.configure({
        API: {//APP Contorol向けのAPI
            aws_appsync_graphqlEndpoint: "https://4vtchgnigzcyni3doeabk4veky.appsync-api.ap-northeast-1.amazonaws.com/graphql",
            aws_appsync_region: "ap-northeast-1",
            aws_appsync_authenticationType: "API_KEY",
            aws_appsync_apiKey: "da2-23ekiri5p5gmdc3jtp7mk4hifa",
        }
    });
    var currentAPI = API.configure();
    console.log('============== AuthClass currentAPI', currentAPI);


    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userInfo };
        temp[name] = value;
        setUserInfo(temp);
    };



    const handleFormSubmit = async (event) => {
        console.log('hoge')

        setLoading(true);

        // ログイン時にカテゴリ選択設定は削除
        sessionStorage.removeItem('productSearchOptionEatIn');
        sessionStorage.removeItem('productSearchOptionTakeout');
        sessionStorage.removeItem('productSearchOptionDelivery');

        const usernameValidation = (str) => {
            console.log(str)
            //var reg = new RegExp(/^[0-9a-zA-Z]*$/);
            var reg = new RegExp(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/);
            var res = reg.test(str);
            return res;
        }

        const passwdValidation = (str) => {
            console.log(str)
            var reg = new RegExp(/^([@a-zA-Z0-9]{8,})$/);
            var res = reg.test(str);
            return res;
        }


        var isID = usernameValidation(userInfo.id);
        console.log(userInfo.id + '\nisID:' + isID)
        var isPass = passwdValidation(userInfo.password);
        console.log(userInfo.password + '\nisPass:' + isPass)

        if (!isID) {
            console.log('ユーザー名は半角英数字が必要です');
            setLoading(false);
            setMessageLogin('ユーザー名は半角英数字が必要です');
            return;
        }

        if (!isPass) {
            console.log('パスワードは半角英数８文字以上です');
            setLoading(false);
            setMessageLogin('パスワードは半角英数８文字以上です');
            return;
        }

        try {
            const user = await Auth.signIn(userInfo.id, userInfo.password);
            //////////////////////////////////////////////////////////////

            // The user directly signs in
            console.log('======== D ==============');
            console.log('ログイン成功');
            // ここでログイン後の処理を実行してください
            localStorage.setItem('ssvId', userInfo.id);
            localStorage.setItem('ssvPw', userInfo.password);

            //画面遷移
            history.push('/shoplist');
            //history.replace({ pathname: "/shoplist" });
            //////////////////////////////////////////////////////////////

        } catch (err) {

            if (err.code === 'UserNotConfirmedException') {
                // サインアップの確認が完了していません
                // この場合、コードを再送信してユーザーを確認する必要があります
                console.log('サインアップの確認が完了していません');
            } else if (err.code === 'PasswordResetRequiredException') {
                // Cognitoコンソールでパスワードがリセットされると、エラーが発生します
                // この場合、forgotPasswordを呼び出してパスワードをリセットする必要があります
            } else if (err.code === 'NotAuthorizedException') {
                console.log('パスワードが間違っています');
                setMessageLogin('パスワードが間違っています')
                setLoading(false);
            } else if (err.code === 'UserNotFoundException') {
                console.log('ユーザー名が間違っています');
                setMessageLogin('ユーザー名が間違っています')
                setLoading(false);
            } else {
                console.log(err);
                // 不明なエラーが発生しました
                console.log('不明なエラーが発生しました');
            }
        }

    };

    console.log(userInfo)


    return (
        <div className={clsx('flex justify-center items-center min-h-full-screen')} id="FirstLogin">

            <div className='box-login'>
                <div className='logo'>
                    <img src={`${process.env.PUBLIC_URL} /assets/Shop/logo_login.png`} />
                </div>
                <div className='tag-service'>
                    <span className='sv'>Sales View</span>
                    <span className='ac'>APP Control</span>
                </div>
                <h2>ログイン</h2>
                <div className='form-login'>
                    <ValidatorForm onSubmit={handleFormSubmit}>
                        <TextValidator
                            //className="mb-6 w-full"
                            variant="outlined"
                            //size="small"
                            //label="ユーザーID"
                            onChange={handleChange}
                            // type="email"
                            name="id"
                            autoComplete="id"
                            value={userInfo.id}
                            validators={['required',]}
                            errorMessages={['入力してください',]}
                            placeholder={'ID'}
                        />
                        <TextValidator
                            //className="mb-6 w-full"
                            //label="パスワード"
                            variant="outlined"
                            //size="small"
                            onChange={handleChange}
                            name="password"
                            type="password"
                            value={userInfo.password}
                            validators={['required']}
                            errorMessages={['入力してください']}
                            placeholder={'パスワード'}
                            autoComplete="current-password"
                        />
                        {messageLogin && <p className="text-error">{messageLogin}</p>}


                        <div className='box-confirm'>
                            {/*<NavLink to='/forgotpassword' className='link-text'>パスワードを忘れた方はこちら</NavLink>*/}
                            <Button
                                style={{ width: '7em', backgroundColor: '#414141', }}
                                variant="contained" disabled={loading} type="submit">
                                ログイン
                            </Button>
                        </div>

                    </ValidatorForm>
                    {/*<NavLink to='/forgotpassword' className='link-text'>パスワードを忘れた方はこちら</NavLink>*/}

                    <p style={{ textAlign: 'center', fontSize: '12px' }}>version 1.0.9</p>
                </div>
            </div>

        </div>
    );

}

export default AuthClass;
